exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scrollbar[data-v-27e21274]::-webkit-scrollbar{width:0!important;display:none!important}.active[data-v-27e21274]{color:var(--portalPrimaryColor)}.active[data-v-27e21274]:before{content:\"\";position:absolute;width:100%;height:3px;background-color:var(--portalPrimaryColor);bottom:-7px}.sub-nav-item[data-v-27e21274]:hover{color:var(--portalPrimaryColor)}", ""]);

// exports
